import { Link, Outlet } from 'react-router'
import { Card, Logo } from '@k1p4/ui'
import { LanguageSwitcher } from '../components/LanguageSwitcher'
import styles from './AuthLayout.module.css'
import { useHomePath } from '../auth/useAuthEntry'
import { useDocumentTitle } from '../components/useDocumentTitle'

/**
 * Wspólna rama ekranów tożsamości (logowanie, rejestracja, reset hasła).
 * Przełącznik PL/EN nad kartą — plan §8.4 [D5].
 */
export function AuthLayout() {
  useDocumentTitle()
  const home = useHomePath()
  return (
    <div className={styles.root}>
      <div className={styles.topbar}>
        <Link to={home} aria-label="k1p4">
          <Logo size={38} withWordmark withTagline />
        </Link>
        <LanguageSwitcher />
      </div>
      <main className={styles.main}>
        <Card pad="lg" className={styles.card}>
          <Outlet />
        </Card>
      </main>
    </div>
  )
}
